<template>
  <component :is="asPage ? 'base-wrapper' : 'div'" :loading="loading">
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-2">
        <base-button @click="onOpenUpload">Tambah Media</base-button>
      </div>
      <datatable :columns="[
        { id: 'name', name: 'Nama' },
        { id: 'type', name: 'Tipe' },
        { id: 'upload', name: 'Tanggal' },
        { id: 'action', name: 'Aksi' },
      ]" :total="productMedia.meta.page.total" :perPage="productMedia.meta.page.perPage"
        :currentPage="productMedia.meta.page.currentPage" @pagechanged="onChangePage">
        <template #tbody="{ classes }">
          <tr v-for="media in productMedia.data" :key="media.id" :class="[classes.tr, 'bg-white']">
            <td :class="[classes.td]">
              {{ media.attributes.filename }}
            </td>
            <td :class="[classes.td]">{{ media.attributes.product_type }}</td>
            <td :class="[classes.td]">
              {{ media.attributes.createdAt | formatDate }}
            </td>
            <td :class="classes.td">
              <div class="flex gap-1">
                <base-button size="sm" :href="media.attributes.fileurl">
                  <Icon icon="heroicons:photo-solid" />
                  Preview
                </base-button>
                <base-button size="sm" color="danger" @click="onOpenDelete(media)">
                  <Icon icon="heroicons:trash-solid" />
                  Hapus
                </base-button>
              </div>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <base-confirm icon-type="badge" type="success" size="max-w-lg" title="Upload Media"
      message="File yang diterima (.png, .jpg, .mp4)" confirm-text="Upload" :visible="uploadModal.visible"
      :disabled="!uploadModal.file" :loading="uploadModal.loading" @confirmed="onConfirmUpload"
      @close="uploadModal.visible = false">
      <template #content>
        <base-input fullwidth :shadow="false" type="file" size="padding-md" inset label="Upload File"
          accept="image/*,video/*" @change="onChangeUploadFile" />
      </template>
    </base-confirm>
    <base-confirm icon-type="badge" title="Hapus Media" message="Media yang dihapus tidak bisa dikembalikan, lanjutkan?"
      confirm-text="Hapus" :visible="deleteModal.visible" :loading="deleteModal.loading"
      @close="deleteModal.visible = false" @confirmed="onConfirmDelete" />
  </component>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: {
    BaseConfirm
  },
  props: {
    asPage: {
      type: Boolean,
      default: true
    },
    productId: String
  },
  data() {
    return {
      loading: false,
      productMedia: {
        data: [],
        meta: {
          page: {},
        },
      },
      deleteModal: {
        visible: false,
        loading: false,
        id: null
      },
      uploadModal: {
        visible: false,
        loading: false,
        file: null
      },
    };
  },
  methods: {
    async loadProductMedia(params) {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/products/${this.productId || this.$route.params.id}/product-media`, {
        params: {
          'page[size]': 5,
          sort: '-createdAt',
          ...params,
        },
      });

      if (!err) {
        this.productMedia = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadProductMedia({
        'page[number]': page,
      });
    },
    onOpenUpload() {
      this.uploadModal.file = null
      this.uploadModal.loading = false
      this.uploadModal.visible = true
    },
    onOpenDelete(media) {
      this.deleteModal.id = media.id
      this.deleteModal.loading = false
      this.deleteModal.visible = true
    },
    async onConfirmDelete() {
      this.deleteModal.loading = true;

      const [, err] = await this.request(`/api/v1/product-medias/${this.deleteModal.id}`, {
        method: 'delete'
      });

      if (!err) {
        this.deleteModal.visible = false

        this.loadProductMedia()
      }

      this.deleteModal.loading = false;
    },
    async onConfirmUpload() {
      this.uploadModal.loading = true;

      const formData = new FormData();

      formData.append('file', this.uploadModal.file);

      const [, err] = await this.request(`/api/v1/products/${this.productId || this.$route.params.id}/-actions/upload-media`, {
        method: 'post',
        data: formData
      });

      if (!err) {
        this.uploadModal.visible = false

        this.loadProductMedia()
      }

      this.uploadModal.loading = false;
    },
    onChangeUploadFile(e) {
      const [files] = e.target.files

      this.uploadModal.file = files ?? null
    }
  },
  created() {
    this.loadProductMedia();
  }
};
</script>
